module.exports = __webpack_public_path__ + "static/mstile-310x150-0a5236eeef53099eb669f39f336d0e2c.png";